import React from 'react';
import { translate } from 'react-i18next';
import { Image, StyleSheet, Switch, Text, View } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { connect } from 'react-redux';
import { IAppStore } from '../reducer';
import leaderboardImage from '../../assets/images/leaderboard.png';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { activateLeaderBoard, closeSetupScreen, deactivateLeaderBoard } from '../actions';
import { Orientation } from '../reducer';
import { IShouldShowOnWorkout, orientationSelector} from '../selectors';
import { DeviceSetupSubScreenHeader } from './DeviceSetup/DeviceSetupSubScreenHeader';
import { HomeWorkoutResponsiveLayout } from './HomeWorkoutResponsiveLayout';

interface IProps {
  orientation: Orientation;
  mirrorIsActive: boolean;
  shouldShowElements: IShouldShowOnWorkout;
  isLeaderboardActivated: boolean;
  t(key: string): string;
  closeSetupScreen(): void;
  disableMirror(): void;
  enableMirror(): void;
  activateLeaderBoard(): void;
  deactivateLeaderBoard(): void;
}

const Leaderboard = ({
  t,
  orientation,
  closeSetupScreen: closeSetupScreenPressed,
  activateLeaderBoard,
  deactivateLeaderBoard,
  isLeaderboardActivated,
}: IProps) => {
  const isPortrait = orientation === 'PORTRAIT';
  const leaderboardContainer = isPortrait
    ? styles.leaderboardContainerPortrait
    : styles.leaderboardContainerLandscape;

  const infoContainer = isPortrait
    ? styles.infoContainerPortrait
    : styles.infoContainerLandscape;

  const leaderboardSwitchMargin = isPortrait ? {marginTop: defaultScale(30)} : { marginTop: defaultScale(73) };

  return (
    <>
      <DeviceSetupSubScreenHeader title={t('leaderboard')} onBackPress={closeSetupScreenPressed} />
      <View style={styles.container}>
        <HomeWorkoutResponsiveLayout>
          <View style={leaderboardContainer}>
            <View style={styles.imageContainer}>
              <Image
                resizeMode={'contain'}
                style={styles.imageAspect}
                source={leaderboardImage}
              />
            </View>
          </View>
          <View style={infoContainer}>
            <ScrollView contentContainerStyle={styles.infoTextContainer}>
              <Text style={styles.infoText}>{t('leaderboardInfo')}</Text>
              <View style={[styles.leaderBoardSwitch, leaderboardSwitchMargin]}>
                <Text style={styles.infoText}>{t('enableLeaderBoard')}</Text>
                <Switch
                  value={isLeaderboardActivated}
                  trackColor={{ false: Theme.GREY_LIGHT, true: Theme.PRIMARY }}
                  thumbColor={Theme.WHITE}
                  ios_backgroundColor={Theme.GREY_LIGHT}
                  onValueChange = {() => {
                    if (isLeaderboardActivated) {
                      deactivateLeaderBoard();
                    } else {
                      activateLeaderBoard();
                    }
                  }}
                />
              </View>
            </ScrollView>
          </View>
        </HomeWorkoutResponsiveLayout>
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  headerRow: {
    justifyContent: 'space-between',
  },
  infoTextContainer: {
    flex: 1,
    justifyContent: 'center',
    margin: defaultScale(19),

  },
  infoText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.WHITE,
  },
  imageContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Theme.GREY_DARK,
  },
  imageAspect: {
    flex: 1,
    aspectRatio: 0.9,
  },
  leaderboardContainerPortrait: {
    flex: 0.6,
  },
  leaderboardContainerLandscape: {
    flex: 1,
  },
  infoContainerPortrait: {
    flex: 0.3,
    padding: defaultScale(15),
  },
  infoContainerLandscape: {
    flex: 1,
    padding: defaultScale(15),
  },
  leaderBoardSwitch: {
   flexDirection: 'row',
   justifyContent: 'space-between',
   alignItems: 'center',
  },
});

const mapStateToProps = (state: IAppStore): Partial<IProps> => {
  return {
    orientation: orientationSelector(state),
    isLeaderboardActivated: state.homeWorkouts.isLeaderboardActivated,
  };
};

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    closeSetupScreen: () => dispatch(closeSetupScreen()),
    activateLeaderBoard: () => dispatch(activateLeaderBoard()),
    deactivateLeaderBoard: () => dispatch(deactivateLeaderBoard()),
  };
};

export const LeaderboardSetup = connect(mapStateToProps, mapDispatchToProps)(
  translate(['homeWorkouts'])(Leaderboard));
